import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getCompleteRegistrationPath = () => {
  return urlHelper('/auth/complete-registration/');
};
